import { render } from "./all-reports.vue?vue&type=template&id=2ce2cdb6&scoped=true"
import script from "./all-reports.vue?vue&type=script&lang=js"
export * from "./all-reports.vue?vue&type=script&lang=js"

import "./all-reports.vue?vue&type=style&index=0&id=2ce2cdb6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce2cdb6"]])

export default __exports__